<div class="slider">
  <div #track class="track bg-tertiary"></div>
  <div class="selected-track bg-primary" [ngStyle]="selectedTrackWidth()"></div>
  <button
    type="button"
    class="thumb btn-primary bg-white"
    [ngStyle]="thumbLeft()"
    [ngClass]="disabled() ? 'border-tertiary' : 'border-primary'"
    (pointerdown)="markAsTouched(); thumbDown.set(true)"
    (keydown)="markAsTouched(); onThumbKeydown($event)"
  ></button>
</div>
